import { Input, Label } from "reactstrap";
import { CategoriesLearning } from "../../../../../Constant";
import { LEARNING_FILTER_DATA } from "../../../../../Data/Learning";

const CategoriesCheckBox = () => {
  return (
    <div className="checkbox-animated">
      <div className="learning-header">
        <span className="f-w-700">{CategoriesLearning}</span>
      </div>
      {LEARNING_FILTER_DATA.map((data, index) => (
        <Label key={index} className="d-block mb-2" htmlFor={`chk-ani-${index}`}>
          <Input className="checkbox_animated" id={`chk-ani-${index}`} type="checkbox" />{data}</Label>
      ))}
    </div>
  );
};

export default CategoriesCheckBox;
